export const appDiscussionRulesIcon = {
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 4.0006C13.8334 3.0006 9.50001 3.00061 9.00003 5.0006C8.02235 8.91138 15.5 7.50061 16.5 11.0006C17.0918 13.0718 14.3334 14.5006 13.5 15.5006" stroke="#081CD2" stroke-width="3" stroke-linecap="round"/>
    <path d="M9.00392 19.8431C11.1706 20.8431 15.5039 20.8431 16.0039 18.8431C16.9816 14.9324 9.49997 16 8.49997 12.5C7.9082 10.4288 10.6706 9.34314 11.5039 8.34314" stroke="#081CD2" stroke-width="3" stroke-linecap="round"/>
  </svg>`,
  name: 'discussion-rules'
};
